<template>
    <div :style="{'max-width': '99%', 'width': '98%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">

        <!-- Loading State -->
        <div v-if="items_being_loaded == true">
            <loading :active="items_being_loaded"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <!-- Main Tabs Container -->
            <div class="tabs-container">
                <b-card no-body>
                    <b-tabs card>
                        
                        <!-- TAB 1: Product Stats (Existing - COMMENTED OUT) -->
                        <!-- <b-tab title="Product Stats" active>
                            <div>
                                <div v-if="items_being_loaded == true">
                                    <loading :active="items_being_loaded" 
                                        :can-cancel="true" 
                                        :is-full-page="false">
                                    </loading>
                                </div>
                                <div v-else>
                                    <div v-if="items_being_loaded == false">
                                        <div v-if="items.length > 0">
                                            <table style="width: 100%;">
                                                <thead>
                                                    <tr>
                                                        <td class="srr">LOCATION</td>
                                                        <td class="srr">IN STOCK</td>
                                                        <td class="srr">7 DAYS SOLD</td>
                                                        <td class="srr">30 DAYS SOLD</td>
                                                        <td class="srr">60 DAYS SOLD</td>
                                                        <td class="srr">90 DAYS SOLD</td>
                                                        <td class="srr">ALL DAYS SOLD</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item,idx in items" v-bind:key="idx">
                                                        <td class="srrv">{{packet.locationsdict[item.location_id]}}</td>
                                                        <td class="srrv" :style="{background: get_background(item.current_stock)}">{{item.current_stock}}</td>
                                                        <td class="srrv" :style="{background: get_background(item.sold_last_7_days)}">{{item.sold_last_7_days}}</td>
                                                        <td class="srrv" :style="{background: get_background(item.sold_last_30_days)}">{{item.sold_last_30_days}}</td>
                                                        <td class="srrv" :style="{background: get_background(item.sold_last_60_days)}">{{item.sold_last_60_days}}</td>
                                                        <td class="srrv" :style="{background: get_background(item.sold_last_90_days)}">{{item.sold_last_90_days}}</td>
                                                        <td class="srrv" style="background: lightgreen">{{item.sold}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div v-else>
                                            <b-alert show variant="warning">NO STATS FOR THE PRODUCT YET</b-alert>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab> -->

                        <!-- TAB 2: Parent/Child Management (Existing) -->
                        <b-tab title="Product Management" v-if="product.is_parent">
                            <div>
                                <div v-if="parent_product_details_being_loaded == true">
                                    <loading :active="parent_product_details_being_loaded" 
                                        :can-cancel="true" 
                                        :is-full-page="false">
                                    </loading>
                                </div>
                                <div v-else>
                                    <div v-if="parent_product_details_being_loaded == false">
                                        <div v-if="children.length > 0">
                                            
                                            <!-- Summary Buttons -->
                                            <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 15px;">
                                                <div>
                                                    <b-button variant="primary">
                                                        <span style="font-size: 12px;">CURRENT SELL PRICE</span>
                                                        <b-badge variant="light">{{formatPrice(children[0].selling_price)}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>

                                                <div>
                                                    <b-button variant="success">
                                                        <span style="font-size: 12px;">NEW SELL PRICE</span>
                                                        <b-badge variant="light">{{formatPrice(sum_children_selling_price())}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>
                                                
                                                <div>
                                                    <b-button variant="primary">
                                                        <span style="font-size: 12px;">LANDED CST</span>
                                                        <b-badge variant="light">{{formatPrice(sum_children_landed_cost())}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>
                                                
                                                <div>
                                                    <b-button variant="primary">
                                                        <span style="font-size: 12px;">WHLSL PRICE</span>
                                                        <b-badge variant="light">{{formatPrice(sum_children_wholesale_price())}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>
                                                
                                                <div>
                                                    <b-button variant="success">
                                                        <span style="font-size: 12px;">CUBES</span>
                                                        <b-badge variant="light">{{formatNumber(sum_children_cubes())}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>
                                                
                                                <div>
                                                    <b-button variant="primary">
                                                        <span style="font-size: 12px;">SPIFF</span>
                                                        <b-badge variant="light">{{formatPrice(product.spiff)}} <span class="sr-only"></span></b-badge>
                                                    </b-button>
                                                </div>

                                                <div>
                                                    <b-button variant="danger" @click="update_product_group_details">
                                                        SAVE
                                                    </b-button>
                                                </div>
                                            </div>

                                            <!-- Child Items Table -->
                                            <table style="width: 100%; margin-top: 5px;">
                                                <thead>
                                                    <tr>
                                                        <td class="srr2" style="width: 130px;">CHILD SKU</td>
                                                        <td class="srr2" style="width: 80px;">ORIG PRICE</td>
                                                        <td class="srr2" style="width: 70px;">QTY</td>
                                                        <td class="srr2" style="width: 80px;">PRICE/UNIT</td>
                                                        <td class="srr2" style="width: 80px;">ORIG TOTAL</td>
                                                        <td class="srr2" style="width: 70px;">RATIO</td>
                                                        <td class="srr2" style="width: 90px;">UNIT GRP PRICE</td>
                                                        <td class="srr2" style="width: 90px;">TOTAL GRP PRICE</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(child, cidx) in children" v-bind:key="cidx">
                                                        <td class="srrv2">{{child.child_product_sku}}</td>
                                                        <td class="srrv2">{{formatPrice(child.child_selling_price)}}</td>
                                                        <td class="srrv2">
                                                            <b-input size="sm" 
                                                                v-model="child.quantity" 
                                                                type="number"
                                                                min="1"
                                                                @input="updateTotalSellingPrice"></b-input>
                                                        </td>
                                                        <td class="srrv2" style="background: #e8f4f8; font-weight: bold;">
                                                            {{formatPrice(child.child_selling_price / child.quantity)}}
                                                        </td>
                                                        <td class="srrv2" style="background: #e8f4f8;">
                                                            {{formatPrice(child.child_selling_price * child.quantity)}}
                                                        </td>
                                                        <td class="srrv2" style="background: #f0f0f0;">
                                                            {{getRatio(child.child_selling_price, child.quantity)}}%
                                                        </td>
                                                        <td class="srrv2" style="background: #fff3cd;">
                                                            <b-input size="sm" 
                                                                v-model="child.unit_selling_price" 
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                @input="updateTotalSellingPrice"></b-input>
                                                        </td>
                                                        <td class="srrv2" style="background: #d4edda; font-weight: bold;">
                                                            {{formatPrice((child.unit_selling_price || 0) * (child.quantity || 1))}}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="srrv2" colspan="5">
                                                            <strong>ORIG TOTAL</strong>
                                                            <b-input size="sm" :disabled="true" style="background: lightblue; color: black; margin-top: 5px;" 
                                                                :value="formatPrice(children.map(function(d){return (parseFloat(d.child_selling_price) || 0.0)}).reduce((partialSum, a) => partialSum + a, 0))">
                                                            </b-input>
                                                        </td>
                                                        <td class="srrv2"></td>
                                                        <td class="srrv2" colspan="2">
                                                            <strong>SELLING PRICE</strong>
                                                            <b-input size="sm" style="background: lightyellow; font-weight: bold; color: black; margin-top: 5px;" 
                                                                v-model="selling_price" type="number" step="0.01" @input="onSellingPriceChange">
                                                            </b-input>
                                                        </td>
                                                    </tr>

                                                    <!-- Summary Row -->
                                                    <tr style="background: #f8f9fa; border-top: 3px solid #dee2e6;">
                                                        <td class="srrv2" colspan="2"></td>
                                                        <td class="srrv2"><strong>Total QTY</strong><br>{{sum_quantities()}}</td>
                                                        <td class="srrv2"></td>
                                                        <td class="srrv2"><strong>Total Orig</strong><br>{{formatPrice(calculate_orig_total())}}</td>
                                                        <td class="srrv2"></td>
                                                        <td class="srrv2"><strong>Total Unit</strong><br>{{formatPrice(sum_unit_prices())}}</td>
                                                        <td class="srrv2" style="background: #d4edda; font-weight: bold;">
                                                            <strong>Total GRP</strong><br>{{formatPrice(sum_children_selling_price())}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-else>
                                            <b-alert show variant="warning">NO CHILD ADDED YET</b-alert>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>

                        <!-- TAB 3: Receiving History (Existing) -->
                        <b-tab title="Receiving History">
                            <div>
                                <div v-if="history_being_loaded">
                                    <loading :active="history_being_loaded" 
                                        :can-cancel="true" 
                                        :is-full-page="false">
                                    </loading>
                                </div>
                                <div v-else>
                                    <div v-if="receivingHistory.length > 0">
                                        <table style="width: 100%;" class="history-table">
                                            <thead>
                                                <tr>
                                                  
                                                    <th class="srr">Location</th>
                                                    <th class="srr">Received Date</th>
                                                    <th class="srr">Source</th>
                                                    <th class="srr">Sale Price</th>
                                                    <th class="srr">Landed</th>
                                                    <th class="srr">Profit Margin</th>
                                                    <th class="srr">Qty Received</th>
                                                    <th class="srr">Sold So Far</th>
                                                    <th class="srr">Balance Stock</th>
                                                    <th class="srr">Total Stock</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(history, idx) in receivingHistory" :key="idx">
                                                  
                                                    <td class="srrv">{{ history.location_name || 'N/A' }}</td>
                                                    <td class="srrv">{{ history.receiving_date_formatted || 'N/A' }}</td>
                                                    <td class="srrv">
                                                        <b-badge :variant="getSourceVariant(history.source_type)">
                                                            {{ history.source_type }}
                                                        </b-badge>
                                                    </td>
                                                    <td class="srrv">${{ formatPrice(history.selling_price) }}</td>
                                                    <td class="srrv">${{ formatPrice(history.landed_cost) }}</td>
                                                    <td class="srrv" :style="{ background: getProfitMarginColor(history.profit_margin) }">
                                                        {{ formatNumber(history.profit_margin) }}%
                                                    </td>
                                                    <td class="srrv">{{ history.quantity_received }}</td>
                                                    <td class="srrv">{{ history.sold_so_far }}</td>
                                                    <td class="srrv" :style="{ background: getBalanceStockColor(history.balance_stock) }">
                                                        {{ history.balance_stock }}
                                                    </td>
                                                    <td class="srrv">{{ history.in_stock }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <b-alert show variant="info">No receiving history found for this product.</b-alert>
                                    </div>
                                </div>
                            </div>
                        </b-tab>

                        <!-- TAB 4: Price Change History (Existing) -->
                        <b-tab title="Price Change History">
                            <div>
                                <div v-if="history_loading">
                                    <loading :active="history_loading" 
                                        :can-cancel="true" 
                                        :is-full-page="false">
                                    </loading>
                                </div>
                                <div v-else>
                                    <!-- Filters -->
                                    <div class="filters-container mb-3">
                                        <b-row>
                                            <b-col md="4">
                                                <b-form-group label="Filter by Field" label-for="field-filter">
                                                    <b-form-select
                                                        id="field-filter"
                                                        v-model="historyFilter.field"
                                                        :options="fieldOptions"
                                                        size="sm"
                                                        @change="applyHistoryFilters"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option value="">All Fields</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3">
                                                <b-form-group label="Start Date" label-for="start-date">
                                                    <b-form-datepicker
                                                        id="start-date"
                                                        v-model="historyFilter.startDate"
                                                        size="sm"
                                                        @input="applyHistoryFilters"
                                                    ></b-form-datepicker>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3">
                                                <b-form-group label="End Date" label-for="end-date">
                                                    <b-form-datepicker
                                                        id="end-date"
                                                        v-model="historyFilter.endDate"
                                                        size="sm"
                                                        @input="applyHistoryFilters"
                                                    ></b-form-datepicker>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="2" class="d-flex align-items-end">
                                                <b-button size="sm" variant="secondary" @click="clearHistoryFilters">
                                                    Clear Filters
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </div>

                                    <div v-if="filteredHistory.length > 0">
                                        <table style="width: 100%;" class="history-table">
                                            <thead>
                                                <tr>
                                                    <th class="srr">Change Date</th>
                                                    <th class="srr">Field</th>
                                                    <th class="srr">Previous Value</th>
                                                    <th class="srr">New Value</th>
                                                    <th class="srr">Changed By</th>
                                                    <th class="srr">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(history, idx) in filteredHistory" :key="idx">
                                                    <td class="srrv">{{ formatDateTime(history.change_date) }}</td>
                                                    <td class="srrv">{{ formatFieldName(history.changed_field) }}</td>
                                                    <td class="srrv" style="color: red;">
                                                        <s>{{ formatValue(history.changed_field, history.previous_value) || 'N/A' }}</s>
                                                    </td>
                                                    <td class="srrv" style="color: green; font-weight: bold;">
                                                        {{ formatValue(history.changed_field, history.new_value) || 'N/A' }}
                                                    </td>
                                                    <td class="srrv">{{ history.changed_by || 'System' }}</td>
                                                    <td class="srrv">
                                                        <b-button size="sm" variant="info" @click="showChangeDetails(history)">
                                                            View
                                                        </b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <b-alert show variant="info">No change history found for this product.</b-alert>
                                    </div>
                                </div>
                            </div>
                        </b-tab>

                        <!-- TAB 5: Selling by Location (DRILL-DOWN) -->
                        <b-tab title="Selling by Location">
                            <div>
                                <!-- Product Info -->
                                <b-alert variant="info" show class="mb-3">
                                    <strong>Product:</strong> {{ product.product_name }} ({{ product.sku }})
                                </b-alert>

                                <!-- Back Button (when viewing salesperson details) -->
                                <div v-if="selectedLocation" class="mb-3">
                                    <b-button variant="secondary" @click="selectedLocation = null">
                                        <b-icon icon="arrow-left"></b-icon> Back to Locations
                                    </b-button>
                                    <span class="ml-2 font-weight-bold">
                                        Location: {{ selectedLocation.location_name }}
                                    </span>
                                </div>

                                <!-- Location-wise Data Table (Clickable) -->
                                <div v-if="!selectedLocation && filteredLocationData.length > 0" class="diver">
                                    <table style="width: 100%; cursor: pointer;">
                                        <thead>
                                            <tr>
                                                <th class="srr" style="width: 200px;">LOCATION</th>
                                                <th class="srr" style="width: 100px;">7 DAYS</th>
                                                <th class="srr" style="width: 100px;">30 DAYS</th>
                                                <th class="srr" style="width: 100px;">60 DAYS</th>
                                                <th class="srr" style="width: 100px;">90 DAYS</th>
                                                <th class="srr" style="width: 100px;">TOTAL SOLD</th>
                                                <th class="srr" style="width: 100px;">CURRENT STOCK</th>
                                                <th class="srr" style="width: 100px;">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in filteredLocationData" :key="idx" 
                                                @click="selectLocation(item)" 
                                                style="cursor: pointer; transition: background 0.2s;"
                                                @mouseenter="hoveredItem = idx" @mouseleave="hoveredItem = null"
                                                :style="hoveredItem === idx ? 'background: #e8f4f8;' : ''">
                                                <td class="srrv">
                                                    <b-icon icon="chevron-right" class="mr-1" style="color: #007bff;"></b-icon>
                                                    {{ item.location_name || 'N/A' }}
                                                </td>
                                                <td class="srrv">{{ item.sold_last_7_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_30_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_60_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_90_days || 0 }}</td>
                                                <td class="srrv" style="font-weight: bold; background: #f0f8ff;">
                                                    {{ item.sold || 0 }}
                                                </td>
                                                <td class="srrv">{{ item.current_stock || 0 }}</td>
                                                <td class="srrv">
                                                    <b-button size="sm" variant="primary" @click.stop="selectLocation(item)">
                                                        View People
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Salesperson-wise Data Table (Drill-down) -->
                                <div v-if="selectedLocation && filteredSalespersonData.length > 0" class="diver">
                                    <table style="width: 100%;">
                                        <thead>
                                            <tr>
                                                <th class="srr" style="width: 200px;">SALESPERSON</th>
                                                <th class="srr" style="width: 100px;">7 DAYS</th>
                                                <th class="srr" style="width: 100px;">30 DAYS</th>
                                                <th class="srr" style="width: 100px;">60 DAYS</th>
                                                <th class="srr" style="width: 100px;">90 DAYS</th>
                                                <th class="srr" style="width: 100px;">TOTAL SOLD</th>
                                                <th class="srr" style="width: 150px;">% OF LOCATION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in filteredSalespersonData" :key="idx">
                                                <td class="srrv">{{ item.salesperson || 'N/A' }}</td>
                                                <td class="srrv">{{ item.sold_last_7_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_30_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_60_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_90_days || 0 }}</td>
                                                <td class="srrv" style="font-weight: bold; background: #f0fff0;">
                                                    {{ item.sold || 0 }}
                                                </td>
                                                <td class="srrv">
                                                    {{ calculatePercentage(item.sold, selectedLocation.sold) }}%
                                                    <b-progress :value="calculatePercentage(item.sold, selectedLocation.sold)" 
                                                                max="100" 
                                                                height="5px" 
                                                                class="mt-1"
                                                                variant="success">
                                                    </b-progress>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div v-else-if="!selectedLocation && filteredLocationData.length === 0" class="text-center py-4">
                                    <b-alert variant="info" show>
                                        <b-icon icon="info-circle"></b-icon>
                                        No location selling history data available for this product
                                    </b-alert>
                                </div>

                                <div v-else-if="selectedLocation && filteredSalespersonData.length === 0" class="text-center py-4">
                                    <b-alert variant="info" show>
                                        <b-icon icon="info-circle"></b-icon>
                                        No salesperson data available for {{ selectedLocation.location_name }}
                                    </b-alert>
                                </div>
                            </div>
                        </b-tab>

                        <!-- TAB 6: Selling by Salesperson -->
                        <b-tab title="Selling by Salesperson">
                            <div>
                                <!-- Product Info -->
                                <b-alert variant="info" show class="mb-3">
                                    <strong>Product:</strong> {{ product.product_name }} ({{ product.sku }})
                                </b-alert>

                                <!-- Back Button (when viewing location details) -->
                                <div v-if="selectedSalesperson" class="mb-3">
                                    <b-button variant="secondary" @click="selectedSalesperson = null">
                                        <b-icon icon="arrow-left"></b-icon> Back to Salespeople
                                    </b-button>
                                    <span class="ml-2 font-weight-bold">
                                        Salesperson: {{ selectedSalesperson.salesperson }}
                                    </span>
                                </div>

                                <!-- Salesperson List (Clickable) -->
                                <div v-if="!selectedSalesperson && filteredSalespersonListData.length > 0" class="diver">
                                    <table style="width: 100%; cursor: pointer;">
                                        <thead>
                                            <tr>
                                                <th class="srr" style="width: 200px;">SALESPERSON</th>
                                                <th class="srr" style="width: 100px;">7 DAYS</th>
                                                <th class="srr" style="width: 100px;">30 DAYS</th>
                                                <th class="srr" style="width: 100px;">60 DAYS</th>
                                                <th class="srr" style="width: 100px;">90 DAYS</th>
                                                <th class="srr" style="width: 100px;">TOTAL SOLD</th>
                                                <th class="srr" style="width: 100px;">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in filteredSalespersonListData" :key="idx" 
                                                @click="selectSalesperson(item)" 
                                                style="cursor: pointer; transition: background 0.2s;"
                                                @mouseenter="hoveredSalesperson = idx" @mouseleave="hoveredSalesperson = null"
                                                :style="hoveredSalesperson === idx ? 'background: #e8f4f8;' : ''">
                                                <td class="srrv">
                                                    <b-icon icon="chevron-right" class="mr-1" style="color: #007bff;"></b-icon>
                                                    {{ item.salesperson || 'N/A' }}
                                                </td>
                                                <td class="srrv">{{ item.sold_last_7_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_30_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_60_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_90_days || 0 }}</td>
                                                <td class="srrv" style="font-weight: bold; background: #f0f8ff;">
                                                    {{ item.sold || 0 }}
                                                </td>
                                                <td class="srrv">
                                                    <b-button size="sm" variant="primary" @click.stop="selectSalesperson(item)">
                                                        View Locations
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Location List for Selected Salesperson -->
                                <div v-if="selectedSalesperson && filteredSalespersonLocationData.length > 0" class="diver">
                                    <table style="width: 100%;">
                                        <thead>
                                            <tr>
                                                <th class="srr" style="width: 200px;">LOCATION</th>
                                                <th class="srr" style="width: 100px;">7 DAYS</th>
                                                <th class="srr" style="width: 100px;">30 DAYS</th>
                                                <th class="srr" style="width: 100px;">60 DAYS</th>
                                                <th class="srr" style="width: 100px;">90 DAYS</th>
                                                <th class="srr" style="width: 100px;">TOTAL SOLD</th>
                                                <th class="srr" style="width: 150px;">% OF SALESPERSON</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in filteredSalespersonLocationData" :key="idx">
                                                <td class="srrv">{{ item.location_name || 'N/A' }}</td>
                                                <td class="srrv">{{ item.sold_last_7_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_30_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_60_days || 0 }}</td>
                                                <td class="srrv">{{ item.sold_last_90_days || 0 }}</td>
                                                <td class="srrv" style="font-weight: bold; background: #f0fff0;">
                                                    {{ item.sold || 0 }}
                                                </td>
                                                <td class="srrv">
                                                    {{ calculatePercentage(item.sold, selectedSalesperson.sold) }}%
                                                    <b-progress :value="calculatePercentage(item.sold, selectedSalesperson.sold)" 
                                                                max="100" 
                                                                height="5px" 
                                                                class="mt-1"
                                                                variant="success">
                                                    </b-progress>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div v-else-if="!selectedSalesperson && filteredSalespersonListData.length === 0" class="text-center py-4">
                                    <b-alert variant="info" show>
                                        <b-icon icon="info-circle"></b-icon>
                                        No salesperson selling history data available for this product
                                    </b-alert>
                                </div>

                                <div v-else-if="selectedSalesperson && filteredSalespersonLocationData.length === 0" class="text-center py-4">
                                    <b-alert variant="info" show>
                                        <b-icon icon="info-circle"></b-icon>
                                        No location data available for {{ selectedSalesperson.salesperson }}
                                    </b-alert>
                                </div>
                            </div>
                        </b-tab>

                        <!-- TAB 7: Inventory Lookup (Child Products Only) -->
                        <b-tab title="Inventory Lookup" v-if="!product.is_parent">
                            <div>
                                <!-- Product Info -->
                                <b-alert variant="info" show class="mb-3">
                                    <strong>Product:</strong> {{ product.product_name }} ({{ product.sku }})
                                    <b-badge variant="secondary" class="ml-2">Child Product</b-badge>
                                </b-alert>

                                <!-- Loading State -->
                                <div v-if="inventory_being_loaded">
                                    <loading :active="inventory_being_loaded" 
                                        :can-cancel="true" 
                                        :is-full-page="false">
                                    </loading>
                                </div>

                                <div v-else>
                                    <!-- Inventory Stats Summary -->
                                    <!-- <div v-if="inventoryData.length > 0" class="mb-3">
                                        <b-row>
                                            <b-col md="3">
                                                <b-card bg-variant="primary" text-variant="white" class="text-center">
                                                    <div style="font-size: 24px; font-weight: bold;">{{ totalInventory }}</div>
                                                    <div style="font-size: 12px;">TOTAL INVENTORY</div>
                                                </b-card>
                                            </b-col>
                                            <b-col md="3">
                                                <b-card bg-variant="success" text-variant="white" class="text-center">
                                                    <div style="font-size: 24px; font-weight: bold;">{{ totalAvailable }}</div>
                                                    <div style="font-size: 12px;">TOTAL AVAILABLE</div>
                                                </b-card>
                                            </b-col>
                                            <b-col md="3">
                                                <b-card bg-variant="warning" text-variant="white" class="text-center">
                                                    <div style="font-size: 24px; font-weight: bold;">{{ totalReserved }}</div>
                                                    <div style="font-size: 12px;">TOTAL RESERVED</div>
                                                </b-card>
                                            </b-col>
                                            <b-col md="3">
                                                <b-card bg-variant="info" text-variant="white" class="text-center">
                                                    <div style="font-size: 24px; font-weight: bold;">{{ inventoryData.length }}</div>
                                                    <div style="font-size: 12px;">LOCATIONS</div>
                                                </b-card>
                                            </b-col>
                                        </b-row>
                                    </div> -->

                                    <!-- Inventory Table -->
                                    <div v-if="inventoryData.length > 0">
                                        <!-- Search and Filter -->
                                        <!-- <b-row class="mb-3">
                                            <b-col md="4">
                                                <b-form-input 
                                                    v-model="inventorySearchQuery" 
                                                    placeholder="Search location..."
                                                    size="sm"
                                                    @input="applyInventorySearchFilter">
                                                </b-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <b-form-select 
                                                    v-model="inventoryStockFilter" 
                                                    :options="stockFilterOptions"
                                                    size="sm"
                                                    @change="applyInventorySearchFilter">
                                                </b-form-select>
                                            </b-col>
                                            <b-col md="4" class="text-right">
                                                <b-button 
                                                    v-if="hasActiveInventoryFilters"
                                                    variant="outline-danger" 
                                                    size="sm"
                                                    @click="clearInventoryFilters">
                                                    <b-icon icon="x-circle"></b-icon> Clear Filters
                                                </b-button>
                                            </b-col>
                                        </b-row> -->

                                        <!-- Results Count -->
                                        <!-- <div class="mb-2" v-if="filteredInventoryData.length > 0">
                                            <b-badge variant="info" class="p-2">
                                                Showing {{ filteredInventoryData.length }} locations
                                            </b-badge>
                                        </div> -->

                                        <!-- Inventory Table -->
                                        <table style="width: 100%;">
                                            <thead>
                                                <tr>
                                                    <th class="srr" style="width: 200px;" @click="sortInventory('location_name')">
                                                        LOCATION 
                                                        <b-icon v-if="inventorySortKey === 'location_name'" 
                                                            :icon="inventorySortAsc ? 'chevron-up' : 'chevron-down'"
                                                            size="sm">
                                                        </b-icon>
                                                    </th>
                                                    <th class="srr" style="width: 100px;" @click="sortInventory('quantity')">
                                                        QTY
                                                        <b-icon v-if="inventorySortKey === 'quantity'" 
                                                            :icon="inventorySortAsc ? 'chevron-up' : 'chevron-down'"
                                                            size="sm">
                                                        </b-icon>
                                                    </th>
                                                    <th class="srr" style="width: 100px;" @click="sortInventory('reserved')">
                                                        RESERVED
                                                        <b-icon v-if="inventorySortKey === 'reserved'" 
                                                            :icon="inventorySortAsc ? 'chevron-up' : 'chevron-down'"
                                                            size="sm">
                                                        </b-icon>
                                                    </th>
                                                    <th class="srr" style="width: 100px;" @click="sortInventory('available')">
                                                        AVAILABLE
                                                        <b-icon v-if="inventorySortKey === 'available'" 
                                                            :icon="inventorySortAsc ? 'chevron-up' : 'chevron-down'"
                                                            size="sm">
                                                        </b-icon>
                                                    </th>
                                                    <th class="srr" style="width: 150px;" @click="sortInventory('last_updated')">
                                                        LAST UPDATED
                                                        <b-icon v-if="inventorySortKey === 'last_updated'" 
                                                            :icon="inventorySortAsc ? 'chevron-up' : 'chevron-down'"
                                                            size="sm">
                                                        </b-icon>
                                                    </th>
                                                    <th class="srr" style="width: 100px;">STATUS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, idx) in filteredInventoryData" :key="idx">
                                                    <td class="srrv" style="font-weight: normal;">
                                                        {{ item.location_name || item.locsub || 'N/A' }}
                                                    </td>
                                                    <td class="srrv" style="font-weight: bold;">
                                                        {{ item.quantity || 0 }}
                                                    </td>
                                                    <td class="srrv">
                                                        {{ item.reserved || 0 }}
                                                    </td>
                                                    <td class="srrv" :style="{ 
                                                        fontWeight: 'bold', 
                                                        background: getInventoryStatusColor(item.available) 
                                                    }">
                                                        {{ item.available || 0 }}
                                                    </td>
                                                    <td class="srrv">
                                                        {{ formatDateTime(item.last_updated) }}
                                                    </td>
                                                    <td class="srrv">
                                                       
                                                            {{ getInventoryStatus(item.available) }}
                                                      
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <!-- Footer with totals -->
                                            <tfoot v-if="filteredInventoryData.length > 0">
                                                <tr style="background: #f8f9fa; font-weight: bold;">
                                                    <td class="srrv" style="background: #e9ecef;">TOTAL</td>
                                                    <td class="srrv" style="background: #e9ecef;">{{ totalInventory }}</td>
                                                    <td class="srrv" style="background: #e9ecef;">{{ totalReserved }}</td>
                                                    <td class="srrv" style="background: #e9ecef;">{{ totalAvailable }}</td>
                                                    <td class="srrv" style="background: #e9ecef;" colspan="2"></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <div v-else>
                                        <b-alert show variant="info">
                                            <b-icon icon="info-circle"></b-icon>
                                            No inventory data available for this product
                                        </b-alert>
                                    </div>
                                </div>
                            </div>
                        </b-tab>

                    </b-tabs>
                </b-card>
            </div>
        </div>

        <!-- Details Modal -->
        <b-modal v-model="showDetailsModal" title="Change Details" size="lg" ok-only>
            <div v-if="selectedChange">
                <b-table striped hover bordered :items="[selectedChange]" :fields="detailFields"></b-table>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from "moment";
    import Requestor from "@/utilities/Requestor";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "ProductStatsModal",
        props: ["viewdata"],
        components: {Loading},
        data: function() {
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                product: {},
                parent_product_details_being_loaded: null,
                children: [],
                selling_price: null,
                new_selling_price: null,
                receivingHistory: [],
                history_being_loaded: null,
                manualPriceUpdate: false,
                isUpdating: false,
                
                // History filters
                changeHistory: [],
                history_loading: false,
                historyFilter: {
                    field: '',
                    startDate: '',
                    endDate: ''
                },
                fieldOptions: [
                    { value: 'product_name', text: 'Product Name' },
                    { value: 'selling_price', text: 'Selling Price' },
                    { value: 'landed_cost', text: 'Landed Cost' },
                    { value: 'fob_price', text: 'FOB Price' },
                    { value: 'wholesale_price', text: 'Wholesale Price' },
                    { value: 'spiff', text: 'Spiff' },
                    { value: 'cubes', text: 'Cubes' },
                    { value: 'category_id', text: 'Category' },
                    { value: 'vendor_id', text: 'Vendor' }
                ],
                showDetailsModal: false,
                selectedChange: null,
                detailFields: [
                    { key: 'change_date', label: 'Change Date' },
                    { key: 'changed_field', label: 'Field' },
                    { key: 'previous_value', label: 'Previous Value' },
                    { key: 'new_value', label: 'New Value' },
                    { key: 'changed_by', label: 'Changed By' }
                ],

                // Location-wise selling history
                locationData: [],
                locationDateRange: 'all_time',
                locationSearchQuery: '',
                hoveredItem: null,
                selectedLocation: null,
                
                // Salesperson-wise selling history
                salespersonData: [],
                salespersonDateRange: 'all_time',
                salespersonSearchQuery: '',
                salespersonListSearchQuery: '',
                salespersonLocationSearchQuery: '',
                hoveredSalesperson: null,
                selectedSalesperson: null,
                
                dateRangeOptions: [
                    { value: '7_days', text: 'LAST 7 DAYS' },
                    { value: '30_days', text: 'LAST 30 DAYS' },
                    { value: '60_days', text: 'LAST 60 DAYS' },
                    { value: '90_days', text: 'LAST 90 DAYS' },
                    { value: '120_days', text: 'LAST 120 DAYS' },
                    { value: 'all_time', text: 'ALL TIME' }
                ],

                // ========== INVENTORY LOOKUP DATA ==========
                inventoryData: [],
                inventory_being_loaded: false,
                inventorySearchQuery: '',
                inventoryStockFilter: 'all',
                inventorySortKey: 'location_name',
                inventorySortAsc: true,
                stockFilterOptions: [
                    { value: 'all', text: 'All Stock' },
                    { value: 'in_stock', text: 'In Stock (>0)' },
                    { value: 'out_of_stock', text: 'Out of Stock (0)' },
                    { value: 'low_stock', text: 'Low Stock (<10)' }
                ]
            }
        },
        watch: {
            selling_price: {
                handler: function(val) {
                    if (this.isUpdating) return;
                    
                    if (this.manualPriceUpdate) {
                        this.manualPriceUpdate = false;
                        return;
                    }
                    
                    this.distributeSellingPrice(val);
                },
                immediate: true
            }
        },
        computed: {
            filteredHistory() {
                let filtered = this.changeHistory;
                
                if (this.historyFilter.field) {
                    filtered = filtered.filter(item => 
                        item.changed_field === this.historyFilter.field
                    );
                }
                
                if (this.historyFilter.startDate) {
                    filtered = filtered.filter(item => 
                        moment(item.change_date).isSameOrAfter(this.historyFilter.startDate)
                    );
                }
                
                if (this.historyFilter.endDate) {
                    filtered = filtered.filter(item => 
                        moment(item.change_date).isSameOrBefore(this.historyFilter.endDate + ' 23:59:59')
                    );
                }
                
                return filtered;
            },

            // Filtered location data (TAB 5)
            filteredLocationData() {
                let items = this.locationData;
                
                if (this.locationSearchQuery) {
                    const query = this.locationSearchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        (item.location_name && item.location_name.toLowerCase().includes(query))
                    );
                }
                
                return items;
            },

            // Filtered salesperson data for Location tab (TAB 5 drill-down)
            filteredSalespersonData() {
                let items = this.salespersonData;
                
                // Filter by selected location
                if (this.selectedLocation) {
                    items = items.filter(item => 
                        item.location_id === this.selectedLocation.location_id
                    );
                }
                
                // Then apply search filter
                if (this.salespersonSearchQuery) {
                    const query = this.salespersonSearchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        (item.salesperson && item.salesperson.toLowerCase().includes(query))
                    );
                }
                
                return items;
            },

            // Filtered salesperson list (TAB 6)
            filteredSalespersonListData() {
                let items = this.salespersonData;
                
                if (this.salespersonListSearchQuery) {
                    const query = this.salespersonListSearchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        (item.salesperson && item.salesperson.toLowerCase().includes(query))
                    );
                }
                
                return items;
            },

            // Filtered salesperson locations (TAB 6 drill-down)
            filteredSalespersonLocationData() {
                let items = this.salespersonData;
                
                // Filter by selected salesperson
                if (this.selectedSalesperson) {
                    items = items.filter(item => 
                        item.salesperson === this.selectedSalesperson.salesperson
                    );
                }
                
                // Then apply location search
                if (this.salespersonLocationSearchQuery) {
                    const query = this.salespersonLocationSearchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        (item.location_name && item.location_name.toLowerCase().includes(query))
                    );
                }
                
                return items;
            },

            // Combined display data for TAB 5
            displayData() {
                if (this.selectedLocation) {
                    return this.filteredSalespersonData;
                }
                return this.filteredLocationData;
            },

            hasActiveLocationFilters() {
                return this.locationSearchQuery !== '' || this.selectedLocation !== null;
            },

            hasActiveSalespersonFilters() {
                return this.salespersonSearchQuery !== '';
            },

            hasActiveSalespersonListFilters() {
                return this.salespersonListSearchQuery !== '' || 
                       this.salespersonLocationSearchQuery !== '' || 
                       this.selectedSalesperson !== null;
            },

            // ========== INVENTORY COMPUTED ==========
            filteredInventoryData() {
                let items = [...this.inventoryData];
                
                // Apply search filter
                if (this.inventorySearchQuery) {
                    const query = this.inventorySearchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        (item.location_name && item.location_name.toLowerCase().includes(query)) ||
                        (item.locsub && item.locsub.toLowerCase().includes(query))
                    );
                }
                
                // Apply stock filter
                if (this.inventoryStockFilter === 'in_stock') {
                    items = items.filter(item => (item.available || 0) > 0);
                } else if (this.inventoryStockFilter === 'out_of_stock') {
                    items = items.filter(item => (item.available || 0) === 0);
                } else if (this.inventoryStockFilter === 'low_stock') {
                    items = items.filter(item => (item.available || 0) > 0 && (item.available || 0) < 10);
                }
                
                // Apply sorting
                if (this.inventorySortKey) {
                    items.sort((a, b) => {
                        let valA = a[this.inventorySortKey] || 0;
                        let valB = b[this.inventorySortKey] || 0;
                        
                        if (typeof valA === 'string') {
                            valA = valA.toLowerCase();
                            valB = valB.toLowerCase();
                        }
                        
                        if (valA < valB) return this.inventorySortAsc ? -1 : 1;
                        if (valA > valB) return this.inventorySortAsc ? 1 : -1;
                        return 0;
                    });
                }
                
                return items;
            },

            totalInventory() {
                return this.inventoryData.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0);
            },

            totalReserved() {
                return this.inventoryData.reduce((sum, item) => sum + (parseInt(item.reserved) || 0), 0);
            },

            totalAvailable() {
                return this.inventoryData.reduce((sum, item) => sum + (parseInt(item.available) || 0), 0);
            },

            hasActiveInventoryFilters() {
                return this.inventorySearchQuery !== '' || this.inventoryStockFilter !== 'all';
            }
        },
        methods: {
            // ========== EXISTING METHODS ==========
            roundToTwo(num) {
                return Math.round((num) * 100) / 100;
            },

            distributeSellingPrice(val) {
                if (this.isUpdating) return;
                this.isUpdating = true;
                
                try {
                    let new_selling_price = parseFloat(val);
                    if (!new_selling_price || new_selling_price <= 0 || this.children.length === 0) {
                        this.isUpdating = false;
                        return;
                    }
                    
                    let total_orig_price = 0;
                    this.children.forEach(child => {
                        const origPrice = parseFloat(child.child_selling_price) || 0;
                        total_orig_price += origPrice;
                    });
                    
                    if (total_orig_price <= 0) {
                        this.isUpdating = false;
                        return;
                    }
                    
                    let totalCalculated = 0;
                    let unitPrices = [];
                    
                    this.children.forEach((child, index) => {
                        const qty = parseFloat(child.quantity) || 1;
                        const origPrice = parseFloat(child.child_selling_price) || 0;
                        const ratio = origPrice / total_orig_price;
                        const totalSellingPrice = new_selling_price * ratio;
                        const unitPrice = totalSellingPrice / qty;
                        const roundedUnitPrice = this.roundToTwo(unitPrice);
                        
                        unitPrices.push({
                            index: index,
                            unitPrice: roundedUnitPrice,
                            totalPrice: roundedUnitPrice * qty
                        });
                        
                        totalCalculated += roundedUnitPrice * qty;
                    });
                    
                    let difference = this.roundToTwo(new_selling_price - totalCalculated);
                    
                    if (Math.abs(difference) > 0.01) {
                        let maxQtyIndex = 0;
                        let maxQty = 0;
                        this.children.forEach((child, index) => {
                            const qty = parseFloat(child.quantity) || 1;
                            if (qty > maxQty) {
                                maxQty = qty;
                                maxQtyIndex = index;
                            }
                        });
                        
                        const qty = parseFloat(this.children[maxQtyIndex].quantity) || 1;
                        const currentUnitPrice = unitPrices.find(u => u.index === maxQtyIndex).unitPrice;
                        const newUnitPrice = this.roundToTwo(currentUnitPrice + (difference / qty));
                        unitPrices.find(u => u.index === maxQtyIndex).unitPrice = newUnitPrice;
                    }
                    
                    unitPrices.forEach(({index, unitPrice}) => {
                        this.children[index].unit_selling_price = unitPrice;
                    });
                    
                    this.new_selling_price = new_selling_price;
                    
                } catch (error) {
                    console.error('Error distributing selling price:', error);
                } finally {
                    this.isUpdating = false;
                }
            },
            
            getRatio(origPrice, qty) {
                if (!this.children || this.children.length === 0) return '0';
                
                const totalOrig = this.children.reduce((sum, child) => {
                    const price = parseFloat(child.child_selling_price) || 0;
                    return sum + price;
                }, 0);
                
                if (totalOrig === 0) return '0';
                
                const ratio = (origPrice / totalOrig) * 100;
                return ratio.toFixed(1);
            },
            
            sum_quantities: function() {
                let total = 0;
                this.children.forEach(child => {
                    total += parseFloat(child.quantity) || 0;
                });
                return total;
            },
            
            calculate_orig_total: function() {
                let total = 0;
                this.children.forEach(child => {
                    const price = parseFloat(child.child_selling_price) || 0;
                    total += price;
                });
                return total;
            },
            
            sum_unit_prices: function() {
                let total = 0;
                this.children.forEach(child => {
                    total += parseFloat(child.unit_selling_price) || 0;
                });
                return total;
            },
            
            updateTotalSellingPrice() {
                if (this.isUpdating) return;
                
                this.manualPriceUpdate = true;
                const total = this.sum_children_selling_price();
                this.selling_price = this.roundToTwo(total);
                this.new_selling_price = this.selling_price;
            },
            
            onSellingPriceChange() {
                // Watch handler will handle distribution
            },
            
            async fetchHistory() {
                if (!this.product || !this.product.sku) return;
                
                this.history_loading = true;
                const path = "/api/product/get_product_change_history/";
                const data = { product_sku: this.product.sku };
                
                try {
                    const response = await new Promise((resolve, reject) => {
                        Requestor.postSyncP(path, data, this, resolve, reject);
                    });
                    
                    if (response.data.result) {
                        this.changeHistory = response.data.result;
                    } else {
                        this.$bvToast.toast(
                            response.data.error || "Error fetching product history",
                            { title: "Error", variant: "warning" }
                        );
                    }
                } catch (error) {
                    console.error('Error fetching product history:', error);
                    this.$bvToast.toast(
                        "Error fetching product history",
                        { title: "Error", variant: "danger" }
                    );
                } finally {
                    this.history_loading = false;
                }
            },
            
            applyHistoryFilters() {
                this.$forceUpdate();
            },
            
            formatDateTime(dateString) {
                if (!dateString) return 'N/A';
                return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
            },
            
            formatFieldName(field) {
                const fieldMap = {
                    'product_name': 'Product Name',
                    'selling_price': 'Selling Price',
                    'landed_cost': 'Landed Cost',
                    'fob_price': 'FOB Price',
                    'wholesale_price': 'Wholesale Price',
                    'spiff': 'Spiff',
                    'cubes': 'Cubes',
                    'category_id': 'Category',
                    'vendor_id': 'Vendor'
                };
                return fieldMap[field] || field;
            },
            
            formatValue(field, value) {
                if (!value) return '';
                
                const numericFields = ['selling_price', 'landed_cost', 'fob_price', 'wholesale_price', 'spiff', 'cubes'];
                if (numericFields.includes(field)) {
                    const num = parseFloat(value);
                    return isNaN(num) ? value : num.toFixed(2);
                }
                
                if (field === 'category_id' && this.packet.categoriesdict) {
                    return this.packet.categoriesdict[value] || value;
                }
                
                if (field === 'vendor_id' && this.packet.vendorsdict) {
                    return this.packet.vendorsdict[value] || value;
                }
                
                return value;
            },
            
            showChangeDetails(change) {
                this.selectedChange = change;
                this.showDetailsModal = true;
            },
            
            clearHistoryFilters() {
                this.historyFilter = {
                    field: '',
                    startDate: '',
                    endDate: ''
                };
                this.applyHistoryFilters();
            },
            
            formatPrice(value) {
                if (value === null || value === undefined) return '0.00';
                try {
                    const num = parseFloat(value);
                    return isNaN(num) ? '0.00' : num.toFixed(2);
                } catch (e) {
                    return '0.00';
                }
            },
            
            formatNumber(value) {
                if (value === null || value === undefined) return '0';
                try {
                    const num = parseFloat(value);
                    return isNaN(num) ? '0' : num.toFixed(2);
                } catch (e) {
                    return '0';
                }
            },
            
            getSourceVariant(sourceType) {
                switch(sourceType) {
                    case 'STOCK_ORDER': return 'primary';
                    case 'CONTAINER_ORDER': return 'success';
                    case 'BACKORDER': return 'warning';
                    default: return 'secondary';
                }
            },
            
            getProfitMarginColor(margin) {
                let marginValue = 0;
                try {
                    marginValue = parseFloat(margin) || 0;
                } catch (e) {
                    marginValue = 0;
                }
                
                if (marginValue > 50) return '#d4edda';
                if (marginValue > 20) return '#fff3cd';
                return '#f8d7da';
            },
            
            getBalanceStockColor(balance) {
                let balanceValue = 0;
                try {
                    balanceValue = parseFloat(balance) || 0;
                } catch (e) {
                    balanceValue = 0;
                }
                
                if (balanceValue > 0) return '#d4edda';
                if (balanceValue < 0) return '#f8d7da';
                return '#fff3cd';
            },
            
            fetch_receiving_history: function() {
                let path = "/api/sales/get_price_receiving_history/";
                let data = { product_sku: this.product.sku };
                let that = this;
                
                let s = function(response) {
                    if (response.data.result) {
                        that.receivingHistory = response.data.result.map(item => ({
                            ...item,
                            selling_price: parseFloat(item.selling_price) || 0,
                            landed_cost: parseFloat(item.landed_cost) || 0,
                            profit_margin: parseFloat(item.profit_margin) || 0,
                            quantity_received: parseInt(item.quantity_received) || 0,
                            sold_so_far: parseInt(item.sold_so_far) || 0,
                            balance_stock: parseInt(item.balance_stock) || 0,
                            in_stock: parseInt(item.in_stock) || 0
                        }));
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error fetching receiving history",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.history_being_loaded = false;
                };
                
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error fetching receiving history",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.history_being_loaded = false;
                };
                
                this.history_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            sum_children_cubes: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_cubes * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_landed_cost: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_landed_cost * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_wholesale_price: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    output += this.children[i].child_wholesale_price * (this.children[i].quantity || 0)
                }
                return output
            },
            
            sum_children_selling_price: function(){
                let output = 0.0;
                for (var i=0; i<this.children.length; i++){
                    const unitPrice = parseFloat(this.children[i].unit_selling_price) || 0;
                    const quantity = parseFloat(this.children[i].quantity) || 0;
                    output += unitPrice * quantity;
                }
                return this.roundToTwo(output);
            },
            
            get_background: function(value){
                if (value > 0){
                    return 'lightyellow'
                }
                else {
                    return 'white'
                }
            },
            
            update_product_group_details: function(){
                let path = "/api/product/update_product_group_details/"
                let that = this;
                let data = {"children": this.children}
                data["parent_product_sku"] = this.children[0].parent_product_sku;
                data["parent_product_selling_price"] = this.new_selling_price;
                data["parent_product_wholesale_price"] = this.sum_children_wholesale_price();
                data["parent_product_landed_cost"] = this.sum_children_landed_cost();
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$emit("changed-product", JSON.stringify({"product_sku": that.product.sku, "selling_price": parseFloat(that.new_selling_price)}));
                        that.$bvToast.toast(
                            "Success", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    
                    that.parent_product_details_being_loaded = false
                    that.fetch_children()
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating group details.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.parent_product_details_being_loaded=false
                }
                this.parent_product_details_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            fetch_init: function(){
                let path = "/api/sales/get_item_stats_v1/"
                let data = {product_sku: this.product.sku, is_parent: this.product.is_parent}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching product stats.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded=false
                }
                this.items_being_loaded = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            fetch_children: function(){
                let that = this;
                if(this.product.is_parent){
                    let path = "/api/product/get_parent_product_details/"
                    let data = {product_sku: this.product.sku}

                    let s = function(response){
                        if (response.data.result){
                            that.children = response.data.result;
                            that.children.forEach(child => {
                                if (!child.unit_selling_price && child.child_selling_price) {
                                    const qty = parseFloat(child.quantity) || 1;
                                    child.unit_selling_price = that.roundToTwo(child.child_selling_price / qty);
                                }
                                if (!child.quantity) {
                                    child.quantity = 1;
                                }
                            });
                            that.updateTotalSellingPrice();
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.parent_product_details_being_loaded = false
                    }
                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error fetching product stats.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.parent_product_details_being_loaded=false
                    }
                    this.parent_product_details_being_loaded = true;
                    Requestor.getAsyncP(path, data, this, s, f);   
                }
            },

            // ========== DRILL-DOWN METHODS ==========
            
            // Select a location to view salespeople (TAB 5)
            selectLocation(location) {
                this.selectedLocation = location;
                this.salespersonSearchQuery = '';
            },

            // Select a salesperson to view their locations (TAB 6)
            selectSalesperson(salesperson) {
                this.selectedSalesperson = salesperson;
                this.salespersonLocationSearchQuery = '';
            },

            // Calculate percentage contribution
            calculatePercentage(value, total) {
                if (!total || total === 0) return 0;
                const percent = (value / total) * 100;
                return Math.round(percent);
            },

            // Fetch location-wise selling history (TAB 5)
            fetchLocationData() {
                if (!this.product || !this.product.sku) {
                    console.warn('No product SKU available');
                    this.locationData = [];
                    return;
                }
                
                // Reset drill-down when date range changes
                this.selectedLocation = null;
                this.salespersonSearchQuery = '';
                
                let that = this;
                let path = "/api/product/get_selling_history_by_location/";
                let data = {
                    date_range: this.locationDateRange,
                    product_sku: this.product.sku,
                    is_parent: this.product.is_parent || false
                };
                
                let s = function(response) {
                    if (response.data.result && response.data.result.length > 0) {
                        that.locationData = response.data.result.map(item => ({
                            ...item,
                            location_name: item.location_name || 'N/A',
                            sold_last_7_days: item.sold_last_7_days || 0,
                            sold_last_30_days: item.sold_last_30_days || 0,
                            sold_last_60_days: item.sold_last_60_days || 0,
                            sold_last_90_days: item.sold_last_90_days || 0,
                            sold: item.sold || 0,
                            current_stock: item.current_stock || 0
                        }));
                        console.log('Location data loaded:', that.locationData.length, 'items');
                    } else {
                        that.locationData = [];
                        console.log('No location data found for product:', that.product.sku);
                        if (response.data.error) {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Info", autoHideDelay: 3000, variant: "warning"}
                            );
                        }
                    }
                };
                
                let f = function(error) {
                    console.log('Error fetching location data:', error);
                    that.$bvToast.toast(
                        "Error fetching location data",
                        {title: "Error", autoHideDelay: 3000, variant: "danger"}
                    );
                    that.locationData = [];
                };
                
                Requestor.getSyncP(path, data, this, s, f);
            },

            // Fetch salesperson-wise selling history (TAB 6)
            fetchSalespersonData() {
                if (!this.product || !this.product.sku) {
                    console.warn('No product SKU available');
                    this.salespersonData = [];
                    return;
                }
                
                // Reset drill-down when date range changes
                this.selectedSalesperson = null;
                this.salespersonListSearchQuery = '';
                this.salespersonLocationSearchQuery = '';
                
                let that = this;
                let path = "/api/product/get_selling_history_by_salesperson/";
                let data = {
                    date_range: this.salespersonDateRange,
                    product_sku: this.product.sku,
                    is_parent: this.product.is_parent || false
                };
                
                let s = function(response) {
                    if (response.data.result && response.data.result.length > 0) {
                        that.salespersonData = response.data.result.map(item => ({
                            ...item,
                            salesperson: item.salesperson || 'N/A',
                            location_name: item.location_name || 'N/A',
                            location_id: item.location_id,
                            sold_last_7_days: item.sold_7d || 0,
                            sold_last_30_days: item.sold_30d || 0,
                            sold_last_60_days: item.sold_60d || 0,
                            sold_last_90_days: item.sold_90d || 0,
                            sold: item.total_sold || 0
                        }));
                        console.log('Salesperson data loaded:', that.salespersonData.length, 'items');
                    } else {
                        that.salespersonData = [];
                        console.log('No salesperson data found for product:', that.product.sku);
                        if (response.data.error) {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Info", autoHideDelay: 3000, variant: "warning"}
                            );
                        }
                    }
                };
                
                let f = function(error) {
                    console.log('Error fetching salesperson data:', error);
                    that.$bvToast.toast(
                        "Error fetching salesperson data",
                        {title: "Error", autoHideDelay: 3000, variant: "danger"}
                    );
                    that.salespersonData = [];
                };
                
                Requestor.getSyncP(path, data, this, s, f);
            },

            // Apply search filters
            applyLocationSearchFilter() {
                // Computed property will auto-update
            },

            applySalespersonSearchFilter() {
                // Computed property will auto-update
            },

            applySalespersonListSearchFilter() {
                // Computed property will auto-update
            },

            applySalespersonLocationSearchFilter() {
                // Computed property will auto-update
            },

            // Clear all filters for Location tab
            clearAllLocationFilters() {
                this.locationSearchQuery = '';
                this.salespersonSearchQuery = '';
                this.selectedLocation = null;
            },

            // Clear all filters for Salesperson tab
            clearAllSalespersonFilters() {
                this.salespersonListSearchQuery = '';
                this.salespersonLocationSearchQuery = '';
                this.selectedSalesperson = null;
            },

            // ========== INVENTORY LOOKUP METHODS ==========
            
            // Fetch inventory data for child product
            fetchInventoryData() {
                if (!this.product || !this.product.sku) {
                    console.warn('No product SKU available for inventory lookup');
                    this.inventoryData = [];
                    return;
                }

                // Only fetch for child products
                if (this.product.is_parent) {
                    this.inventoryData = [];
                    return;
                }

                this.inventory_being_loaded = true;
                let that = this;
                let path = "/api/inventory/loc_sub_product_inventory/";
                let data = {
                    product_query: this.product.sku
                };

                // Add location filter if user has location restrictions
                if (this.packet.userDetails && this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    data.location_id = this.packet.userDetails.properties.location_id;
                }

                let s = function(response) {
                    if (response.data.result) {
                        that.inventoryData = response.data.result.map(item => {
                            // Get location name from locsubsdict (same as LookupInventory component)
                            let locationName = 'N/A';
                            if (item.locsub && that.packet.locsubsdict) {
                                locationName = that.packet.locsubsdict[item.locsub] || 'N/A';
                            }
                            
                            return {
                                ...item,
                                location_name: locationName,
                                location_id: item.location_id || null,
                                quantity: parseInt(item.nitems) || 0,
                                reserved: parseInt(item.reserved) || 0,
                                available: parseInt(item.available) || 0,
                                last_updated: item.last_updated || new Date().toISOString(),
                                locsub: item.locsub || 'N/A'
                            };
                        });
                        console.log('Inventory data loaded:', that.inventoryData.length, 'locations');
                    } else {
                        that.inventoryData = [];
                        if (response.data.error) {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Info", autoHideDelay: 3000, variant: "warning"}
                            );
                        }
                    }
                    that.inventory_being_loaded = false;
                };

                let f = function(error) {
                    console.log('Error fetching inventory data:', error);
                    that.$bvToast.toast(
                        "Error fetching inventory data",
                        {title: "Error", autoHideDelay: 3000, variant: "danger"}
                    );
                    that.inventoryData = [];
                    that.inventory_being_loaded = false;
                };

                Requestor.postSyncP(path, data, this, s, f);
            },

            // Apply inventory search filter
            applyInventorySearchFilter() {
                // Computed property will auto-update
            },

            // Sort inventory data
            sortInventory(key) {
                if (this.inventorySortKey === key) {
                    this.inventorySortAsc = !this.inventorySortAsc;
                } else {
                    this.inventorySortKey = key;
                    this.inventorySortAsc = true;
                }
            },

            // Clear inventory filters
            clearInventoryFilters() {
                this.inventorySearchQuery = '';
                this.inventoryStockFilter = 'all';
            },

            // Get inventory status color
            getInventoryStatusColor(available) {
                const value = parseInt(available) || 0;
                if (value > 10) return '#d4edda';  // Green - In stock
                if (value > 0) return '#fff3cd';   // Yellow - Low stock
                return '#f8d7da';                   // Red - Out of stock
            },

            // Get inventory badge variant
            getInventoryBadgeVariant(available) {
                const value = parseInt(available) || 0;
                if (value > 10) return 'success';
                if (value > 0) return 'warning';
                return 'danger';
            },

            // Get inventory status text
            getInventoryStatus(available) {
                const value = parseInt(available) || 0;
                if (value > 10) return 'In Stock';
                if (value > 0) return 'Low Stock';
                return 'Out of Stock';
            }
        },
        
        mounted: async function(){
            await Promise.all([
                this.fetch_init(),
                this.fetch_children(),
                this.fetch_receiving_history(),
                this.fetchHistory()
            ]);
            
            // Load selling data AFTER product is loaded
            if (this.product && this.product.sku) {
                console.log('Loading selling data for product SKU:', this.product.sku);
                this.fetchLocationData();
                this.fetchSalespersonData();
                
                // Load inventory data for child products
                if (!this.product.is_parent) {
                    console.log('Loading inventory data for child product:', this.product.sku);
                    this.fetchInventoryData();
                }
            }
        },
        
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.categories.splice(0, 0, {value: null, text: "ALL"});
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.product = JSON.parse(JSON.stringify(this.viewdata)); 
            this.selling_price = parseFloat(JSON.stringify(this.product.selling_price));
            
            console.log('Product loaded in modal:', this.product.sku);
            console.log('locsubsdict available:', this.packet.locsubsdict ? 'Yes' : 'No');
        }
    }
</script>

<style scoped>
.filters-container .form-group {
    margin-bottom: 0.5rem;
}

.filters-container .b-form-group-label {
    padding-bottom: 0.25rem;
}

.filters-container .b-form-group-label label {
    font-size: 0.875rem;
    font-weight: 500;
}

.filters-container .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
}

.filters-container .btn-group-sm > .btn,
.filters-container .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

.filters-container .b-form-datepicker {
    max-width: 100%;
}

.filters-container .b-form-datepicker .form-control {
    font-size: 0.875rem;
}

.tabs-container {
    margin-top: 10px;
}

.history-table {
    font-size: 11px;
}

.history-table th,
.history-table td {
    padding: 4px 6px;
    text-align: center;
    white-space: nowrap;
}

.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
    cursor: pointer;
}

.srrv {
    font-size: 11px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.srr2 {
    font-size: 14px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
}

.srrv2 {
    font-size: 14px !important;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.srrv2 input {
    text-align: center;
}

.srrv2 input[type="number"] {
    width: 100%;
    padding: 4px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

.srrv2 input[type="number"]:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.diver {
    overflow: auto;
    width: 100%;
}

td, th {
    border: 1px solid;
}

th {
    background-color: white;
}

table {
    table-layout: fixed;
    width: 100%;
}

.filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: end;
}

.mr-1 {
    margin-right: 0.25rem;
}

/* Hover effect for location rows */
tbody tr {
    transition: background 0.2s ease;
}

tbody tr:hover {
    background: #e8f4f8 !important;
}

/* Inventory status colors */
.bg-success-light {
    background: #d4edda !important;
}

.bg-warning-light {
    background: #fff3cd !important;
}

.bg-danger-light {
    background: #f8d7da !important;
}

/* Clickable headers */
th.srr {
    cursor: pointer;
    user-select: none;
}

th.srr:hover {
    background: #e0e0e0;
}

@media (max-width: 1200px) {
    .srrv2 {
        font-size: 12px !important;
        padding: 3px !important;
    }
    
    .srrv2 input {
        font-size: 12px !important;
    }
}

@media (max-width: 768px) {
    .filters-row .col-md-3 {
        margin-bottom: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Products/ProductStatsModal.vue